import React from "react";
import styled from "styled-components";

export const Heading = styled.p`
   text-align: left; 
  font-family: Montserrat Alternates-Bold;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0px;
  color: #909090;
  opacity: 1;
  font-weight: bold;
  margin-top: 3px;
  margin-bottom: 0px;
  margin-left: 40px;
`;